<template>
    <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row ec_breadcrumb_inner">
                        <div class="col-md-6 col-sm-12">
                            <h2 class="ec-breadcrumb-title">{{ $t('Cart') }}</h2>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <!-- ec-breadcrumb-list start -->
                            <ul class="ec-breadcrumb-list">
                                <li class="ec-breadcrumb-item"><router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >{{ $t('Home') }}</router-link></li>
                                <li class="ec-breadcrumb-item active">{{ $t('Cart') }}</li>
                            </ul>
                            <!-- ec-breadcrumb-list end -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Ec cart page -->
    <section class="ec-page-content section-space-p"   v-if="cartItems?.length > 0">
        <div class="container">
            <div class="row">
                <div class="ec-cart-leftside col-lg-8 col-md-12 ">
                    <!-- cart content Start -->
                    <div class="ec-cart-content">
                        <div class="ec-cart-inner">
                            <div class="row">
                                <form action="#">
                                    <div class="table-content cart-table-content table-responsive">
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>{{ $t('Product name') }}</th>
                                                <th>{{ $t('Price') }}</th>
                                                <th style="text-align: center;">{{ $t('Qty') }}</th>
                                                <th>{{ $t('Total') }}</th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="cartItem in cartItems" :key="cartItem.id">
                                                <!-- عمود اسم المنتج -->
                                                <td data-label="Product" class="ec-cart-pro-name">
                                                    <router-link
                                                        v-if="cartItem.product"
                                                        :to="{name: 'products.show', params: { id: cartItem.product.id, lang : $i18n.locale }}"
                                                        class="ec-cart-pro-img mr-4">
                                                        <img :src="cartItem.product.image ?? '/images/spices-jar.jpeg'"
                                                             :alt="cartItem.product?.name">
                                                    </router-link>
                                                    <span v-else class="ec-cart-item-unknown">Product Unknown</span>
                                                    {{ cartItem.product?.name ?? 'Unknown Product' }}
                                                </td>

                                                <!-- عمود السعر -->
                                                <td data-label="Price" class="ec-cart-pro-price">
                                                    <span v-if="cartItem.product" class="amount">
                                                        {{ cartItem.product.price_tax }} {{ $t('SAR') }}
                                                    </span>
                                                    <span v-else>N/A</span>
                                                </td>

                                                <!-- عمود الكمية -->
                                                <td data-label="Quantity" class="ec-cart-pro-qty" style="text-align: center;">
                                                    <CartButton v-if="cartItem.product" :product="cartItem.product" :cart="cartItem" :type="'cart-qty-plus-minus'"></CartButton>
                                                    <span v-else>{{ cartItem.quantity }}</span>
                                                </td>

                                                <!-- عمود الإجمالي -->
                                                <td data-label="Total" class="ec-cart-pro-subtotal">
                                                    <span v-if="cartItem.product">
                                                        {{ parseFloat(cartItem.quantity * cartItem.product.price_tax).toFixed(2) }} {{ $t('SAR') }}
                                                    </span>
                                                    <span v-else>N/A</span>
                                                </td>

                                                <!-- عمود إزالة المنتج -->
                                                <td data-label="Remove" class="ec-cart-pro-remove">
                                                    <a class="close_button btn btn-light btn-sm text-danger"
                                                       @click="removeFromCart(cartItem.id)">
                                                        <i class="ecicon eci-trash-o"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                            </tbody>

                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="ec-cart-update-bottom">

                                                <router-link :to="{name: 'home', params: { lang : $i18n.locale  }}">
                                                    {{ $t('Continue shopping') }}
                                                </router-link>

                                                <router-link :to="{name: 'checkout', params: { lang : $i18n.locale  }}"
                                                             class="btn btn-primary text-white">
                                                    {{ $t('Proceed to checkout') }}
                                                </router-link>

                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <!--cart content End -->
                </div>
                <!-- Sidebar Area Start -->
                <div class="ec-cart-rightside col-lg-4 col-md-12">
                    <div class="ec-sidebar-wrap">
                        <!-- Sidebar Summary Block -->
                        <div class="ec-sidebar-block">
                            <div class="ec-sb-title">
                                <h3 class="ec-sidebar-title">{{ $t('Order Summery') }}</h3>
                            </div>
                            <div class="ec-sb-block-content">
                                <div class="ec-cart-summary-bottom">
                                    <div class="ec-cart-summary">
                                        <div>
                                            <span class="text-left">{{ $t('Subtotal') }}</span>
                                            <span class="text-right">{{ subtotal }} {{ $t('SAR') }}</span>
                                        </div>
                                        <div>
                                            <span class="text-left">{{ $t('Shipping and delivery') }}</span>
                                            <span class="text-right">{{ main.settings?.shipping_cost }} {{ $t('SAR') }}</span>
                                        </div>
                                        <div >
                                            <span class="text-left">{{ $t('Tax') }}</span>
                                            <span class="text-right">{{ tax }} {{ $t('SAR') }}</span>
                                        </div>
                                        <!--                                        <div class="ec-cart-coupan-content">-->
<!--                                            <form class="ec-cart-coupan-form" name="ec-cart-coupan-form" method="post"-->
<!--                                                  action="#">-->
<!--                                                <input class="ec-coupan" type="text" required=""-->
<!--                                                       placeholder="Enter Your Coupan Code" name="ec-coupan" value="">-->
<!--                                                <button class="ec-coupan-btn button btn-primary" type="submit"-->
<!--                                                        name="subscribe" value="">Apply-->
<!--                                                </button>-->
<!--                                            </form>-->
<!--                                        </div>-->
                                        <div class="ec-cart-summary-total">
                                            <span class="text-left">{{ $t('Total') }}</span>
                                            <span class="text-right">{{ total }} {{ $t('SAR') }}</span>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                        <!-- Sidebar Summary Block -->
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="container"  v-else>

        <div class="alert alert-danger">
            {{ $t('No items in cart') }}
        </div>

    </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import CartButton from "./CartButton.vue";
import Utility from "../../utility";

import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    components: {CartButton},
    props: ['main'],
    data() {
        return {
            wrappers: [],
        }
    },
    async created() {
        // await this.getResults(1);
    },
    computed: {
        ...mapGetters(['cartItems']), // استمرار في استخدام الحاصل cartItems

        subtotal() {
            return parseFloat(
                this.cartItems.reduce((subtotal, cartItem) => {
                    // إضافة القيمة فقط إذا كان product متاحًا
                    return cartItem.product ? subtotal + cartItem.quantity * cartItem.product.price : subtotal;
                }, 0)
            ).toFixed(2);
        },

        tax() {
            return parseFloat(
                (parseFloat(this.subtotal)+ parseFloat(this.main?.settings?.shipping_cost ?? 0) ) * 0.15 // الضريبة المضافة كنسبة من الإجمالي
                // (parseFloat(this.subtotal)+ parseFloat(this.main?.settings?.shipping_cost ?? 0) ) * 0.0 // الضريبة المضافة كنسبة من الإجمالي
            ).toFixed(2);
        },

        total() {
            return parseFloat(
                parseFloat(this.subtotal) +
                parseFloat(this.tax) +
                parseFloat(this.main?.settings?.shipping_cost ?? 0) // تكاليف الشحن إن وجدت
            ).toFixed(2);
        },
    },
    methods: {
        ...mapActions(['addToCart', 'removeFromCart']), // Map the addToCart and removeFromCart actions
        // Your other methods here

        // async getResults(page) {
        //     const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-light fa-filter-list'});
        //     await axios.get('wrappers', { params: { page: page, } } ).then(response => {
        //         toast.dismiss(id);
        //         this.wrappers = response.data;
        //     }, response => {
        //         toast.dismiss(id);
        //     });
        //
        // },

    },
};

</script>
